// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    VersionAPIModel,
    VersionAPIModelFromJSON,
    VersionAPIModelToJSON,
} from '../models';

/**
 * AppApi - interface
 * 
 * @export
 * @interface AppApiInterface
 */
export interface AppApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApiInterface
     */
    appControllerGetRootRaw(): Promise<runtime.ApiResponse<VersionAPIModel>>;

    /**
     */
    appControllerGetRoot(): Promise<VersionAPIModel>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApiInterface
     */
    appControllerGetVersionRaw(): Promise<runtime.ApiResponse<VersionAPIModel>>;

    /**
     */
    appControllerGetVersion(): Promise<VersionAPIModel>;

}

/**
 * 
 */
export class AppApi extends runtime.BaseAPI implements AppApiInterface {

    /**
     */
    async appControllerGetRootRaw(): Promise<runtime.ApiResponse<VersionAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async appControllerGetRoot(): Promise<VersionAPIModel> {
        const response = await this.appControllerGetRootRaw();
        return await response.value();
    }

    /**
     */
    async appControllerGetVersionRaw(): Promise<runtime.ApiResponse<VersionAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/version`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async appControllerGetVersion(): Promise<VersionAPIModel> {
        const response = await this.appControllerGetVersionRaw();
        return await response.value();
    }

}
